(() => {
  if (window.asCardRowsReady) return;
  window.asCardRowsReady = true;
  const records = new WeakMap();
  let frame = 0;
  const activeGrids = new Set();
  const observedGrids = new WeakSet();
  let gridSizes = new WeakMap();
  const nearViewport = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) activeGrids.add(entry.target);
      else activeGrids.delete(entry.target);
    });
    schedule();
  }, {rootMargin: '250px 0px'}) : null;
  const number = value => parseFloat(value) || 0;
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  function wrapTitle(link) {
    if (link.dataset.asWrappedTitle) return;
    const text = link.textContent.trim().replace(/\s+([)\]}])/g, '$1').replace(/(\S)[ \t]+(\S)$/, '$1\u00a0$2');
    const parts = text.split(/(\/)/);
    const fragment = document.createDocumentFragment();
    parts.forEach(part => {
      fragment.append(document.createTextNode(part));
      if (part === '/') fragment.append(document.createElement('wbr'));
    });
    link.replaceChildren(fragment);
    link.dataset.asWrappedTitle = 'true';
  }
  function reset(record) {
    record.wrapper.classList.remove('as-card-row-aligned');
    record.wrapper.style.removeProperty('--as-card-info-height');
    record.wrapper.style.removeProperty('--as-card-brand-height');
    record.title.style.removeProperty('font-size');
    record.link.style.removeProperty('font-size');
    record.meta.style.removeProperty('flex');
  }
  function update() {
    frame = 0;
    const all = [];
    document.querySelectorAll('.product-card-wrapper').forEach(wrapper => {
      if (wrapper.closest('quick-add-modal, .card--horizontal')) return;
      const card = wrapper.querySelector(':scope > .card');
      const info = card?.querySelector(':scope > .card__content > .card__information');
      const title = info?.querySelector(':scope > .card__heading');
      const link = title?.querySelector('a');
      const meta = info?.querySelector(':scope > .card-information');
      const price = meta?.querySelector(':scope > .price--card');
      const grid = wrapper.closest('.product-grid, .grid, .slider');
      if (!card || !link || !meta || !price || !grid) return;
      if (!observedGrids.has(grid)) {
        observedGrids.add(grid);
        if (nearViewport) nearViewport.observe(grid);
        else activeGrids.add(grid);
      }
      if (!activeGrids.has(grid)) return;
      let record = records.get(wrapper);
      if (!record || record.info !== info) {
        record = {wrapper, card, info, title, link, meta, price, grid};
        records.set(wrapper, record);
      }
      all.push(record);
    });
    const candidates = new Map();
    all.forEach(record => {
      if (!candidates.has(record.grid)) candidates.set(record.grid, []);
      candidates.get(record.grid).push(record);
    });
    const pending = [];
    candidates.forEach((cards, grid) => {
      const width = grid.getBoundingClientRect().width;
      const previous = gridSizes.get(grid);
      if (previous && Math.abs(previous.width - width) < 1 && previous.cards.length === cards.length && previous.cards.every((card, index) => card.wrapper === cards[index].wrapper)) return;
      gridSizes.set(grid, {width, cards});
      pending.push(...cards);
    });
    pending.forEach(record => { reset(record); wrapTitle(record.link); });
    const grids = new Map();
    pending.forEach(record => {
      const rows = grids.get(record.grid) || [];
      grids.set(record.grid, rows);
      const top = record.wrapper.getBoundingClientRect().top;
      let row = rows.find(item => Math.abs(item.top - top) < 3);
      if (!row) { row = {top, cards: []}; rows.push(row); }
      row.cards.push(record);
    });
    grids.forEach(rows => rows.forEach(({cards}) => align(cards)));
  }
  function align(cards) {
    if (cards.length < 2) return;
    const maximum = selector => Math.max(0, ...cards.map(record => {
      return Math.max(0, ...Array.from(record.info.querySelectorAll(selector), node => node.getClientRects().length ? node.getBoundingClientRect().height : 0));
    }));
    const compare = maximum('.price__sale s.price-item');
    const from = maximum('.as-card-price__from');
    const line = maximum('.as-card-price__line');
    const brand = maximum('.card-information > .caption-with-letter-spacing');
    if (!line) return;
    cards.forEach(record => {
      record.originalHeight = record.card.getBoundingClientRect().height;
      record.infoHeight = record.info.getBoundingClientRect().height;
      record.fontSize = number(getComputedStyle(record.title).fontSize);
    });
    cards.forEach(record => {
      record.wrapper.style.setProperty('--as-card-info-height', record.infoHeight + 'px');
      record.wrapper.style.setProperty('--as-card-brand-height', brand + 'px');
      record.wrapper.style.setProperty('--as-card-compare-height', compare + 'px');
      record.wrapper.style.setProperty('--as-card-from-height', from + 'px');
      record.wrapper.style.setProperty('--as-card-amount-height', line + 'px');
      record.wrapper.classList.add('as-card-row-aligned');
      record.meta.style.flex = '0 0 auto';
    });
    const budget = Math.min(...cards.map(record => {
      const style = getComputedStyle(record.info);
      return record.infoHeight - number(style.paddingTop) - number(style.paddingBottom) - record.meta.getBoundingClientRect().height;
    }));
    if (budget <= 0) { cards.forEach(reset); return; }
    for (let scale = 1; scale >= 0.7; scale -= 0.025) {
      cards.forEach(record => {
        const size = Math.max(12, record.fontSize * scale);
        record.title.style.setProperty('font-size', size + 'px', 'important');
        record.link.style.setProperty('font-size', size + 'px', 'important');
      });
      if (cards.every(record => record.title.getBoundingClientRect().height <= budget + 0.5 && record.title.scrollWidth <= record.title.clientWidth + 1)) break;
    }
    const titleHeight = Math.max(...cards.map(record => record.title.getBoundingClientRect().height));
    if (titleHeight > budget + 0.5) { cards.forEach(reset); return; }
    cards.forEach(record => {
      record.meta.style.removeProperty('flex');
    });
    if (cards.some(record => record.card.getBoundingClientRect().height > record.originalHeight + 1 || record.info.scrollHeight > record.info.clientHeight + 1)) cards.forEach(reset);
  }
  const init = () => {
    if (document.fonts && document.fonts.status !== 'loaded') document.fonts.ready.then(schedule);
    else schedule();
    window.addEventListener('resize', schedule, {passive: true});
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', () => { gridSizes = new WeakMap(); schedule(); });
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(changes => {
      if (changes.some(change => [...change.addedNodes, ...change.removedNodes].some(node => node.nodeType === 1 && (node.matches?.('.product-card-wrapper') || node.querySelector?.('.product-card-wrapper'))))) { gridSizes = new WeakMap(); schedule(); }
    }).observe(main, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
